export enum ToolType {
    BOX = "#box-template",
    SPHERE = "#sphere-template",
    CYLINDER = "#cylinder-template",
    CONE = "#cone-template",
    PLANE = "#plane-template",
    OBJECT = "#object-template",
    PERSON = "#person-template"
}